/* eslint-disable no-unused-vars */
const A3 = {
  width: 297,
  height: 420
}
const A4 = {
  width: 210,
  height: 297
}
const A5 = {
  width: 148,
  height: 210
}
const A6 = {
  width: 105,
  height: 148
}
/* eslint-enable no-unused-vars */
export default class Page {
  static getSize (format, orientation) {
    var size = eval(format.toUpperCase())
    if (orientation === 'h') {
      [size.width, size.height] = [size.height, size.width]
    }
    return size
  }
}
